import React, { Component } from 'react';
import { Link } from 'react-router-dom';
class BlogGrid extends Component {
  render() {
    let publicUrl = process.env.PUBLIC_URL+'/'
    let imagealt = 'image'
    return (
		<div className="ltn__blog-area ltn__blog-item-3-normal mb-100 go-top">
			<div className="container">
			<div className="row">
				{/* Blog Item */}
				<div className="col-lg-4 col-sm-6 col-12">
				<div className="ltn__blog-item ltn__blog-item-3">
					<div className="ltn__blog-img">
					<Link to="/blog-details"><img src={publicUrl+"assets/img/blog/blog-1.jpg"} alt="#" /></Link>
					</div>
					<div className="ltn__blog-brief">
					{/* <div className="ltn__blog-meta">
						<ul>
						<li className="ltn__blog-author go-top">
							<Link to="/team-details"><i className="far fa-user" />by: Admin</Link>
						</li>
						<li className="ltn__blog-tags go-top">
							<Link to="/service"><i className="fas fa-tags" />Services</Link>
						</li>
						</ul>
					</div> */}
					<h3 className="ltn__blog-title"><Link to="/blog-details">Why Investing in Land is a Smart Long-Term Move</Link></h3>
					<div className="ltn__blog-meta-btn">
						{/* <div className="ltn__blog-meta">
						<ul>
							<li className="ltn__blog-date"><i className="far fa-calendar-alt" />June 24, 2020</li>
						</ul>
						</div> */}
						<div className="ltn__blog-btn" style={{ backgroundColor: '#A3BA3F', color: '#fff', padding: '10px', borderRadius: '10px' }}>
							<Link to="/blog-details">Read more</Link>
						</div>
					</div>
					</div>
				</div>
				</div>
				{/* Blog Item */}
				<div className="col-lg-4 col-sm-6 col-12">
				<div className="ltn__blog-item ltn__blog-item-3">
					<div className="ltn__blog-img">
					<Link to="/blog-details-2"><img src={publicUrl+"assets/img/blog/blog-2.jpg"} alt="#" /></Link>
					</div>
					<div className="ltn__blog-brief">
					{/* <div className="ltn__blog-meta">
						<ul>
						<li className="ltn__blog-author go-top">
							<Link to="/team-details"><i className="far fa-user" />by: Admin</Link>
						</li>
						<li className="ltn__blog-tags go-top">
							<Link to="/service"><i className="fas fa-tags" />Services</Link>
						</li>
						</ul>
					</div> */}
					<h3 className="ltn__blog-title"><Link to="/blog-details-2">Top Mistakes First-Time Plot Buyers Make — and How to Avoid Them</Link></h3>
					<div className="ltn__blog-meta-btn">
						{/* <div className="ltn__blog-meta">
						<ul>
							<li className="ltn__blog-date"><i className="far fa-calendar-alt" />July 23, 2020</li>
						</ul>
						</div> */}
						<div className="ltn__blog-btn" style={{ backgroundColor: '#A3BA3F', color: '#fff', padding: '10px', borderRadius: '10px' }}>
							<Link to="/blog-details-2">Read more</Link>
						</div>
					</div>
					</div>
				</div>
				</div>
				{/* Blog Item */}
				<div className="col-lg-4 col-sm-6 col-12">
				<div className="ltn__blog-item ltn__blog-item-3">
					<div className="ltn__blog-img">
					<Link to="/blog-details-3"><img src={publicUrl+"assets/img/blog/blog-3.jpg"} alt="#" /></Link>
					</div>
					<div className="ltn__blog-brief">
					{/* <div className="ltn__blog-meta">
						<ul>
						<li className="ltn__blog-author go-top">
							<Link to="/team-details"><i className="far fa-user" />by: Admin</Link>
						</li>
						<li className="ltn__blog-tags go-top">
							<Link to="/service"><i className="fas fa-tags" />Services</Link>
						</li>
						</ul>
					</div> */}
					<h3 className="ltn__blog-title"><Link to="/blog-details-3">The Rise of Sustainable Living: Why Green Plots Are Gaining Popularity</Link></h3>
					<div className="ltn__blog-meta-btn">
						{/* <div className="ltn__blog-meta">
						<ul>
							<li className="ltn__blog-date"><i className="far fa-calendar-alt" />August 22, 2020</li>
						</ul>
						</div> */}
						<div className="ltn__blog-btn" style={{ backgroundColor: '#A3BA3F', color: '#fff', padding: '10px', borderRadius: '10px'}}>
							<Link to="/blog-details-3">Read more</Link>
						</div>
					</div>
					</div>
				</div>
				</div>
				{/* Blog Item */}
				<div className="col-lg-4 col-sm-6 col-12">
				<div className="ltn__blog-item ltn__blog-item-3">
					<div className="ltn__blog-img">
					<Link to="/blog-details-4"><img src={publicUrl+"assets/img/blog/blog-4.jpg"} alt="#" /></Link>
					</div>
					<div className="ltn__blog-brief">
					{/* <div className="ltn__blog-meta">
						<ul>
						<li className="ltn__blog-author go-top">
							<Link to="/team-details"><i className="far fa-user" />by: Admin</Link>
						</li>
						<li className="ltn__blog-tags go-top">
							<Link to="/service"><i className="fas fa-tags" />Services</Link>
						</li>
						</ul>
					</div> */}
					<h3 className="ltn__blog-title"><Link to="/blog-details-4">What to Look for in a Gated Layout Before You Invest</Link></h3>
					<div className="ltn__blog-meta-btn">
						{/* <div className="ltn__blog-meta">
						<ul>
							<li className="ltn__blog-date"><i className="far fa-calendar-alt" />June 24, 2020</li>
						</ul>
						</div> */}
						<div className="ltn__blog-btn" style={{ backgroundColor: '#A3BA3F', color: '#fff', padding: '10px', borderRadius: '10px'}}>
							<Link to="/blog-details-4">Read more</Link>
						</div>
					</div>
					</div>
				</div>
				</div>
				{/* Blog Item */}
				<div className="col-lg-4 col-sm-6 col-12">
				<div className="ltn__blog-item ltn__blog-item-3">
					<div className="ltn__blog-img">
					<Link to="/blog-details-5"><img src={publicUrl+"assets/img/blog/blog-5.jpg"} alt="#" /></Link>
					</div>
					<div className="ltn__blog-brief">
					{/* <div className="ltn__blog-meta">
						<ul>
						<li className="ltn__blog-author go-top">
							<Link to="/team-details"><i className="far fa-user" />by: Admin</Link>
						</li>
						<li className="ltn__blog-tags go-top">
							<Link to="/service"><i className="fas fa-tags" />Services</Link>
						</li>
						</ul>
					</div> */}
					<h3 className="ltn__blog-title"><Link to="/blog-details-5">How to Choose the Right Location for Your Future Home</Link></h3>
					<div className="ltn__blog-meta-btn">
						{/* <div className="ltn__blog-meta">
						<ul>
							<li className="ltn__blog-date"><i className="far fa-calendar-alt" />June 24, 2020</li>
						</ul>
						</div> */}
						<div className="ltn__blog-btn" style={{ backgroundColor: '#A3BA3F', color: '#fff', padding: '10px', borderRadius: '10px'}}>
							<Link to="/blog-details-5">Read more</Link>
						</div>
					</div>
					</div>
				</div>
				</div>
				{/* Blog Item */}
				<div className="col-lg-4 col-sm-6 col-12">
				<div className="ltn__blog-item ltn__blog-item-3">
					<div className="ltn__blog-img">
					<Link to="/blog-details-6"><img src={publicUrl+"assets/img/blog/blog-6.jpg"} alt="#" /></Link>
					</div>
					<div className="ltn__blog-brief">
					{/* <div className="ltn__blog-meta">
						<ul>
						<li className="ltn__blog-author go-top">
							<Link to="/team-details"><i className="far fa-user" />by: Admin</Link>
						</li>
						<li className="ltn__blog-tags go-top">
							<Link to="/service"><i className="fas fa-tags" />Services</Link>
						</li>
						</ul>
					</div> */}
					<h3 className="ltn__blog-title"><Link to="/blog-details-6">The Importance of Quality Assurance in Today’s Competitive Market</Link></h3>
					<div className="ltn__blog-meta-btn">
						{/* <div className="ltn__blog-meta">
						<ul>
							<li className="ltn__blog-date"><i className="far fa-calendar-alt" />June 24, 2020</li>
						</ul>
						</div> */}
						<div className="ltn__blog-btn" style={{ backgroundColor: '#A3BA3F', color: '#fff', padding: '10px', borderRadius: '10px'}}>
							<Link to="/blog-details-6">Read more</Link>
						</div>
					</div>
					</div>
				</div>
				</div>
				{/* Blog Item */}
				<div className="col-lg-4 col-sm-6 col-12">
				<div className="ltn__blog-item ltn__blog-item-3">
					<div className="ltn__blog-img">
					<Link to="/blog-details-7"><img src={publicUrl+"assets/img/blog/blog-7.jpg"} alt="#" /></Link>
					</div>
					<div className="ltn__blog-brief">
					{/* <div className="ltn__blog-meta">
						<ul>
						<li className="ltn__blog-author go-top">
							<Link to="/team-details"><i className="far fa-user" />by: Admin</Link>
						</li>
						<li className="ltn__blog-tags go-top">
							<Link to="/service"><i className="fas fa-tags" />Services</Link>
						</li>
						</ul>
					</div> */}
					<h3 className="ltn__blog-title"><Link to="/blog-details-7">Why Efficient Supply Chain Management is a Game Changer</Link></h3>
					<div className="ltn__blog-meta-btn">
						{/* <div className="ltn__blog-meta">
						<ul>
							<li className="ltn__blog-date"><i className="far fa-calendar-alt" />June 24, 2020</li>
						</ul>
						</div> */}
						<div className="ltn__blog-btn" style={{ backgroundColor: '#A3BA3F', color: '#fff', padding: '10px', borderRadius: '10px'}}>
							<Link to="/blog-details-7">Read more</Link>
						</div>
					</div>
					</div>
				</div>
				</div>
				{/* Blog Item */}
				<div className="col-lg-4 col-sm-6 col-12">
				<div className="ltn__blog-item ltn__blog-item-3">
					<div className="ltn__blog-img">
					<Link to="/blog-details-8"><img src={publicUrl+"assets/img/blog/blog-8.jpg"} alt="#" /></Link>
					</div>
					<div className="ltn__blog-brief">
					{/* <div className="ltn__blog-meta">
						<ul>
						<li className="ltn__blog-author go-top">
							<Link to="/team-details"><i className="far fa-user" />by: Admin</Link>
						</li>
						<li className="ltn__blog-tags go-top">
							<Link to="/service"><i className="fas fa-tags" />Services</Link>
						</li>
						</ul>
					</div> */}
					<h3 className="ltn__blog-title"><Link to="/blog-details-8">The Role of Customer Support in Building Long-Term Business Relationships</Link></h3>
					<div className="ltn__blog-meta-btn">
						{/* <div className="ltn__blog-meta">
						<ul>
							<li className="ltn__blog-date"><i className="far fa-calendar-alt" />June 24, 2020</li>
						</ul>
						</div> */}
						<div className="ltn__blog-btn" style={{ backgroundColor: '#A3BA3F', color: '#fff', padding: '10px', borderRadius: '10px'}}>
							<Link to="/blog-details-8">Read more</Link>
						</div>
					</div>
					</div>
				</div>
				</div>
				{/* Blog Item */}
				<div className="col-lg-4 col-sm-6 col-12">
				<div className="ltn__blog-item ltn__blog-item-3">
					<div className="ltn__blog-img">
					<Link to="/blog-details-9"><img src={publicUrl+"assets/img/blog/blog-9.jpg"} alt="#" /></Link>
					</div>
					<div className="ltn__blog-brief">
					{/* <div className="ltn__blog-meta">
						<ul>
						<li className="ltn__blog-author go-top">
							<Link to="/team-details"><i className="far fa-user" />by: Admin</Link>
						</li>
						<li className="ltn__blog-tags go-top">
							<Link to="/service"><i className="fas fa-tags" />Services</Link>
						</li>
						</ul>
					</div> */}
					<h3 className="ltn__blog-title"><Link to="/blog-details-9">Embracing Innovation in Traditional Industries</Link></h3>
					<div className="ltn__blog-meta-btn">
						{/* <div className="ltn__blog-meta">
						<ul>
							<li className="ltn__blog-date"><i className="far fa-calendar-alt" />June 24, 2020</li>
						</ul>
						</div> */}
						<div className="ltn__blog-btn" style={{ backgroundColor: '#A3BA3F', color: '#fff', padding: '10px', borderRadius: '10px'}}>
							<Link to="/blog-details-9">Read more</Link>
						</div>
					</div>
					</div>
				</div>
				</div>
				{/*  */}
				<div className="col-lg-4 col-sm-6 col-12">
				<div className="ltn__blog-item ltn__blog-item-3">
					<div className="ltn__blog-img">
					<Link to="/blog-details-10"><img src={publicUrl+"assets/img/blog/blog-10.jpg"} alt="#" /></Link>
					</div>
					<div className="ltn__blog-brief">
					{/* <div className="ltn__blog-meta">
						<ul>
						<li className="ltn__blog-author go-top">
							<Link to="/team-details"><i className="far fa-user" />by: Admin</Link>
						</li>
						<li className="ltn__blog-tags go-top">
							<Link to="/service"><i className="fas fa-tags" />Services</Link>
						</li>
						</ul>
					</div> */}
					<h3 className="ltn__blog-title"><Link to="/blog-details-10">Choosing the Right Business Partner: What to Look For</Link></h3>
					<div className="ltn__blog-meta-btn">
						{/* <div className="ltn__blog-meta">
						<ul>
							<li className="ltn__blog-date"><i className="far fa-calendar-alt" />June 24, 2020</li>
						</ul>
						</div> */}
						<div className="ltn__blog-btn" style={{ backgroundColor: '#A3BA3F', color: '#fff', padding: '10px', borderRadius: '10px'}}>
							<Link to="/blog-details-10">Read more</Link>
						</div>
					</div>
					</div>
				</div>
				</div>
			</div>
			{/* <div className="row">
				<div className="col-lg-12">
				<div className="ltn__pagination-area text-center">
					<div className="ltn__pagination">
					<ul>
						<li><Link to="#"><i className="fas fa-angle-double-left" /></Link></li>
						<li><Link to="#">1</Link></li>
						<li className="active"><Link to="#">2</Link></li>
						<li><Link to="#">3</Link></li>
						<li><Link to="#">...</Link></li>
						<li><Link to="#">10</Link></li>
						<li><Link to="#"><i className="fas fa-angle-double-right" /></Link></li>
					</ul>
					</div>
				</div>
				</div>
			</div> */}
			</div>
		</div>
	  
    )
  }
}

export default BlogGrid;
